import React from 'react';
import Message from  "./components/Message";

const App = () => {
  
  return (
    <div><Message/>
    </div>
  );
};

export default App;
